import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateCreatorFitMasterPromptPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.GET],
  skipInvalidation: false,
};

export function useUpdateScriptVetMasterPrompt(config?: {
  onSuccess?: () => void;
}) {
  const updateScriptVetMasterPrompt = useCallback(
    (payload: IUpdateCreatorFitMasterPromptPayload) =>
      AiWorkspaceService.updateScriptingRequestMasterPrompt(payload).catch(
        async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to update master prompt")
          );
          throw err;
        }
      ),
    []
  );

  const { mutate: update, isLoading: isUpdating } =
    useMutation<IUpdateCreatorFitMasterPromptPayload>({
      mutationFn: updateScriptVetMasterPrompt,
      options: QUERY_OPTIONS,
      onSuccess: config?.onSuccess,
    });

  return { update, isUpdating };
}
